<template>
  <van-pull-refresh v-model="refreshing" @refresh="refreshList" class="h-100">
    <van-list
      v-if="list.length > 0"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="moreList"
    >
      <slot name="list"></slot>
    </van-list>
    <van-empty v-if="list.length == 0 && finished" description="空空如也" />
  </van-pull-refresh>
</template>

<script>
export default {
  model: {
    prop: "list",
    event: "changeList",
  },
  props: {
    list: {
      type: Array,
      default: [],
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    getList: {
      type: Function,
      default: function (page, pageSize, params) {
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            resolve([]);
          });
        });
      },
    },
    params: {
      type: Object,
      default: null,
    },
    getParams: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      showPopup: false, //分类面板展开状态
      refreshing: false,
      loading: false,
      finished: false,
      myList: this.list,
      page: 1,
    };
  },
  mounted() {
    this.refreshList();
  },
  methods: {
    //刷新列表
    refreshList() {
      let that = this;
      that.finished = false;
      let { page, pageSize, params, getParams } = that;
      if (getParams) {
        params = getParams();
      }
      that.getList(1, pageSize, params).then((data) => {
        that.page = 1;
        that.myList.splice(0, that.myList.length);
        that.myList.push(...data.list);
        that.refreshing = false;
        that.loading = false;
        that.finished = !data.hasNextPage;
      });
    },

    //更多列表
    moreList() {
      let that = this;
      if (that.refreshing) {
        that.myList = [];
        that.refreshing = false;
      }
      let { page, pageSize, params, getParams } = that;
      if (getParams) {
        params = getParams();
      }
      that.getList(page + 1, pageSize, params).then((data) => {
        that.page = page + 1;
        data.list.forEach((item) => {
          that.myList.push(item);
        });
        this.loading = false;
        that.finished = !data.hasNextPage;
      });
    },
  },
  watch: {
    list(newVal) {
      this.myList = newVal;
    },
    myList: {
      deep: true,
      handler: function (newVal) {
        this.$emit("changeList", newVal);
      },
    },
    params(newVal) {},
  },
};
</script>

<style lang="scss" scoped></style>
